import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Customer = () => {
    document.title = "Müştəri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Müştəri", value: "/cash/customer", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Müştəri</h2>
                    <p>
                        Kassa proqramında icra olunan satışlar zamanı Müştəri ilə əməliyyatlar etmək üçün nəzərdə tutulub
                        <ol>
                            <li>
                                <b>Müştəri</b> düyməsini sıxıb açılan pəncərədə siyahıdan müştəriləri seçmək lazımdır. Məhsul səbətə əlavə olunduqdan sonra
                                Müştərinin endirimi ümumi satış məbləğinə şamil olunacaq
                            </li>
                            <li>
                                <b>Müştəri</b> düyməsini sıxıb açılan pəncərədə müştərilərin <mark>bonus</mark> balansına, <mark>borc</mark>larına nəzarət etmək
                                və <mark>Yeni müştəri</mark> əlavə etmək olar
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/customer.gif" alt="Müştəri" />
                </article>
            </div>
        </div>
    );
};
